module.exports = __webpack_public_path__ + "static/media/JNH-25.80c95d36.jpg";